import { render, staticRenderFns } from "./InfoConveniosPage.vue?vue&type=template&id=19ae7521&scoped=true"
import script from "./InfoConveniosPage.js?vue&type=script&lang=js&external"
export * from "./InfoConveniosPage.js?vue&type=script&lang=js&external"
import style0 from "./InfoConveniosPage.vue?vue&type=style&index=0&id=19ae7521&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ae7521",
  null
  
)

export default component.exports